<template>
	<div class="content" ref="content">
		<template v-if="isPc">
			<template v-if="isWX == true">
				<!-- 试题 -->
				<el-row
					v-if="code == '0' && !isAnswered"
					:gutter="20"
					class="content_row"
					:style="{
						backgroundImage: `url(${style.appearance.bgImg})`,
						backgroundRepeat: style.appearance.bgLocation == 0 ? 'repeat' : 'no-repeat',
						backgroundSize: style.appearance.bgLocation == 1 ? 'cover' : 'inherit',
						backgroundColor: style.appearance.bgColor
					}"
				>
					<template v-if="dialogVisible == false">
						<AppearancePC
							ref="AppearancePC"
							id="printExam"
							@addEventListener="handleonmousedown"
							:quanxian="quanxian"
							:bandingstyle="style"
							:percentage="percentage"
							:data="data"
							:quotaList="quotaList"
							:isBank="isBank"
							:isStaging="isStaging"
							@submit="submit"
						></AppearancePC>

						<div class="footer-box" v-if="quanxian && quanxian.allowBeforePreview == 1"><el-button size="medium" v-print="'#printExam'">{{$t('UserAnswer.PreviewOrPrint')}}</el-button></div>
						<!-- </el-col> -->
					</template>
					<div v-else-if="dialogVisible" class="tips-box">
						<p class="title">{{$t('UserAnswer.YouHaveAlreadyAnswered')}}:{{ answeredNumber }}{{$t('UserAnswer.Question')}},{{$t('UserAnswer.DoYouWantToContinue')}}?</p>
						<div class="footer">
							<el-button size="medium" @click="answerAgain">{{$t('UserAnswer.ReAnswerQuestions')}}</el-button>
							<el-button size="medium" type="primary" @click="dialogVisible = false">{{$t('UserAnswer.ContinueAnsweringQuestions')}}</el-button>
						</div>
					</div>
				</el-row>
				<!-- 未到时间 -->
				<el-row v-if="code == '2002' || code == '1001' || isAnswered" :gutter="20" class="content_row">
					<el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
					<el-col :span="16" class="isNotStartTime">
						<p class="title">{{ tipTitle }}</p>
						<p class="tips">{{ message }}</p>
						<p class="date" v-if="examStartTime">{{ examStartTime }}{{$t('UserAnswer.TheQuestionnaireWillBeOpen')}}</p>
					</el-col>
					<el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
				</el-row>
				<!-- 密码 -->
				<el-row v-else-if="code == '2000' || code == '2001'" :gutter="20" class="content_row">
					<el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
					<el-col :span="16" class="isPassword">
						<p class="title">{{$t('UserAnswer.EnterQuestionnairePassword')}}</p>
						<div class="input_box">
							<el-input :class="{ input__err: passwordError }" class="input" :placeholder="$t('UserAnswer.EnterPassword')" v-model="password" show-password></el-input>
							<div v-show="passwordError" class="form-item__error">
								<span>{{ passwordErrorTip }}</span>
							</div>
						</div>
						<el-button class="btn" type="primary" @click="confirmPassword">{{$t('UserAnswer.Determine')}}</el-button>
					</el-col>
					<el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
				</el-row>
				<!-- 提交后提示框 -->
				<el-dialog :visible.sync="dialogthinkVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
					<div class="submittedSuccess">
						<p class="title">{{ tipTitle }}</p>
						<p class="tips" v-if="quotaTips">{{ quotaTips }}</p>
						<!-- <p class="tips" v-else-if="quanxian.ifCustomJump == 1 && quanxian.customJump == 0 && quanxian.manyThanks">{{ quanxian.manyThanks }}</p> -->
						<p class="tips" v-else  v-html="endMsg"></p>
						<p class="wx-share">
							{{$t('UserAnswer.ShareTo')}}
							<i @click="shareToWX"></i>
						</p>
						<p class="thank">
							<span v-if="quanxian.ifAllowStatistics == 1">{{$t('UserAnswer.ClickToView')}}</span>
							<span v-if="quanxian.ifAllowStatistics == 1" class="score link" @click="viewStatistics">{{$t('UserAnswer.Statistics')}}</span>
							<!-- <span v-if="quanxian.showRanking == 1" class="Ranking-list link" @click="toRankingList">排行榜</span> -->
						</p>
					</div>
					<el-dialog class="wx-share-dialog" width="30%" :title="$t('UserAnswer.ShareOnWeChatMoments')" :visible.sync="wxShareVisible" append-to-body :close-on-click-modal="false">
						<div>
							<div class="qrCode" style=""><canvas ref="qrCodeImg" class="qrCode-img"></canvas></div>
						</div>
					</el-dialog>
				</el-dialog>
				<el-dialog
					:title="$t('UserAnswer.WantToContinue')"
					:visible.sync="continueDialogVisible"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					:before-close="continueBeforClose"
					width="30%"
				>
					<span>{{$t('UserAnswer.NoActionTaken')}}</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="submit">{{$t('UserAnswer.SubmitTo')}}{{ submitCountdown }}</el-button>
						<el-button type="primary" @click="continueBeforClose">{{$t('UserAnswer.ContinueAnsweringQuestions')}}</el-button>
					</span>
				</el-dialog>
				<el-dialog
					:title="`${$t('UserAnswer.YouHaveLeftTheExam')}${cutScreenNum}${$t('UserAnswer.Times')}`"
					:visible.sync="cutScreenDialogVisible"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					:before-close="cutScreenContinue"
					width="30%"
				>
					<span>{{$t('UserAnswer.Leave')}}{{ quanxian.cutScreenNum }}{{$t('UserAnswer.WillBeForcedToSubmitThePaper')}}</span>
					<span slot="footer" class="dialog-footer"><el-button type="primary" @click="cutScreenContinue">{{$t('UserAnswer.ContinueAnsweringQuestions')}}</el-button></span>
				</el-dialog>
			</template>
			<div v-else-if="isWX == false" class=" isWx-content isWx-content-pc">
				<div class="isWX-tips-box">
					<p class="title">{{$t('UserAnswer.NeedToOpenOnWeChat')}}</p>
					<p class="tips-describe">{{$t('UserAnswer.ScanQRCodeUsingWeChat')}}</p>
					<div class="qrCode" style=""><canvas ref="qrCodeImg" class="qrCode-img"></canvas></div>
				</div>
			</div>
		</template>

		<template v-else>
			<template v-if="isWX == true && wxLogin == false">
				<template v-if="code == '0' && !isAnswered">
					<template v-if="dialogVisible == false">
						<AppearanceTM
							ref="AppearanceTM"
							@addEventListener="handleonmousedown"
							:percentage="percentage"
							:bandingstyle="stylePhone"
							:quanxian="quanxian"
							:data="data"
							:isStaging="isStaging"
							@submit="submit"
							:quotaList="quotaList"
						></AppearanceTM>
					</template>
					<div v-else-if="dialogVisible" class="TM-continue-tips-box">
						<p class="title">{{$t('UserAnswer.YouHaveAlreadyAnswered')}}{{ answeredNumber }}{{$t('UserAnswer.Question')}},{{$t('UserAnswer.DoYouWantToContinue')}}?</p>
						<div class="footer">
							<el-button size="medium" @click="answerAgain">{{$t('UserAnswer.ReAnswerQuestions')}}</el-button>
							<el-button size="medium" type="primary" @click="dialogVisible = false">{{$t('UserAnswer.ContinueAnsweringQuestions')}}</el-button>
						</div>
					</div>
				</template>

				<!-- 未到时间 -->
				<div v-if="code == '2002' || code == '1001' || isAnswered" class="TM-content">
					<div class="TM-tips-box ">
						<p class="title">{{ tipTitle }}</p>
						<p class="tips">{{ message }}</p>
						<p class="date" v-if="examStartTime">{{ examStartTime }}{{$t('UserAnswer.TheQuestionnaireWillBeOpen')}}</p>
					</div>
				</div>
				<!-- 密码 -->
				<div v-else-if="code == '2000' || code == '2001'" class="TM-content">
					<div class="TM-isPassword">
						<p class="title">{{$t('UserAnswer.EnterQuestionnairePassword')}}</p>
						<div class="input_box">
							<el-input :class="{ input__err: passwordError }" class="input" :placeholder="$t('UserAnswer.EnterPassword')" v-model="password" show-password></el-input>
							<div v-show="passwordError" class="form-item__error">
								<span>{{ passwordErrorTip }}</span>
							</div>
						</div>
						<el-button class="btn" type="primary" @click="confirmPassword">{{$t('UserAnswer.Determine')}}</el-button>
					</div>
				</div>
				<!-- 提交后提示框 -->
				<el-dialog :visible.sync="dialogthinkVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" width="90%">
					<div class="TM-submittedSuccess">
						<p class="title">{{ tipTitle }}</p>

						<p class="tips" v-if="quotaTips">{{ quotaTips }}</p>
						<!-- <p class="tips" v-else-if="quanxian.ifCustomJump == 1 && quanxian.customJump == 0 && quanxian.manyThanks">{{ quanxian.manyThanks }}</p> -->
						<p class="tips" v-else  v-html="endMsg"></p>
						<p class="thank">
							<span v-if="quanxian.ifAllowStatistics == 1">{{$t('UserAnswer.ClickToView')}}</span>
							<span v-if="quanxian.ifAllowStatistics == 1" class="score link" @click="viewStatistics">{{$t('UserAnswer.Statistics')}}</span>
							<!-- <span v-if="quanxian.showRanking == 1" class="Ranking-list link" @click="toRankingListTM">排行榜</span> -->
						</p>
					</div>
				</el-dialog>
				<el-dialog
					class="TM-Dialog"
					:title="$t('UserAnswer.WantToContinue')"
					:visible.sync="continueDialogVisible"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					:before-close="continueBeforClose"
					width="90%"
				>
					<span>{{$t('UserAnswer.NoActionTaken')}}</span>
					<span slot="footer" class="dialog-footer">
						<el-button size="medium" @click="submit">{{$t('UserAnswer.SubmitTo')}}{{ submitCountdown ? submitCountdown : '' }}</el-button>
						<el-button size="medium" type="primary" @click="continueBeforClose">{{$t('UserAnswer.ContinueAnsweringQuestions')}}</el-button>
					</span>
				</el-dialog>
				<el-dialog
					class="TM-Dialog"
					:title="`${$t('UserAnswer.YouHaveLeftTheExam')}${cutScreenNum}${$t('UserAnswer.Times')}`"
					:visible.sync="cutScreenDialogVisible"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					:before-close="cutScreenContinue"
					width="90%"
				>
					<span>{{$t('UserAnswer.Leave')}}{{ quanxian.cutScreenNum }}{{$t('UserAnswer.WillBeForcedToSubmitThePaper')}}</span>
					<span slot="footer" class="dialog-footer"><el-button type="primary" @click="cutScreenContinue">{{$t('UserAnswer.ContinueAnsweringQuestions')}}</el-button></span>
				</el-dialog>
			</template>
			<div v-else-if="isWX == false" class="isWx-content">
				<div class="isWX-tips-box">
					<p class="title">{{$t('UserAnswer.NeedToOpenOnWeChat')}}</p>
					<p class="tips-describe">{{$t('UserAnswer.CopyThisPageAddress')}}</p>
				</div>
			</div>
			<div v-if="wxLogin == true" class="isWx-content">
				<div class="isWX-tips-box">
					<p class="title">{{$t('UserAnswer.WeChatLoginRequired')}}</p>
					<el-button class="wx-login" @click="userLoginWX">{{$t('UserAnswer.OneClickLogin')}}</el-button>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import QrCode from 'qrcode';
import AppearancePC from './components/userAnswer/appearancePC.vue';
import { v1 as UUID } from 'uuid';
import AppearanceTM from './components/userAnswer/appearanceTM.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import wx from 'weixin-js-sdk';
import { randomSelection } from './js/userAnswer/randomSelection/randomSelection';
import { GetAnswerList } from './js/userAnswer/getAnswerList';
import { doVerifyQuota } from './js/userAnswer/doVerifyQuota';
import { SetAnswer } from '@/page/myQuestionnaire/js/userAnswer/setAnswer';

export default {
	components: {
		AppearancePC,
		AppearanceTM
	},
	name: 'UserAnswer',
	props: {
		isPreviewPc: {
			type: Number,
			default: 0
		},
		styleData: {
			type: Object,
			default: () => {
				return {
					appearance: {},
					appearancePhone: {},
					subjectColor: ''
				};
			}
		},
        isBank: {
            type: Boolean,
            default: false // true 题库预览
        },
	},
	data() {
		return {
			isStaging: false, // 是否使用了暂存的答案
			wxLogin: false,
			isPc: true,
			id: '',
			percentage: 0,
			customColor: '#50E6A7',
			data: {},
			noAnswerData: {},
			endTime: '',
			list: [],
			style: {
				// pc端外观
				appearance: {
					bgImg: '',
					buttonContent: this.$t('UserAnswer.SubmitTo'),
					displayTitle: 1,
					displayQuestionsno: 1
				},
				subjectColor: ''
			},
			stylePhone: {
				appearancePhone: {
					bgImg: '',
					displayTitle: 1,
					buttonContent: this.$t('UserAnswer.SubmitTo'),
					displayQuestionsno: 1
				},
				subjectColor: ''
			},
			quanxian: {
				title: '234'
			},
			underwayId: '',
			isStartTime: false, // 是否到考试开始时间
			answerExceedTimer: '', // 考试结束超出时间倒计时
			examEnded: false, // 考试已结束
			// storageTimerChange: '',
			password: '',
			showPassword: false,
			passwordError: false,
			passwordErrorTip: '',
			dialogthinkVisible: false,
			examStartTime: '', // 考试开始时间
			code: '',
			message: '',
			dialogVisible: false,
			answeredNumber: 0, // 已答题目数量
			isAnswered: false,
			openId: '',
			WXcode: '',
			// WXtoken: '',
			isWX: true,
			submitCountdown: 10,
			continueDialogVisible: false,
			submitCountdownTimer: '',
			cutScreenNum: 0,
			cutScreenDialogVisible: false,
			isFullFlag: false, // 全屏状态
			tipTitle: '',
			loadingInstance: false,
			submitloading: this.$t('UserAnswer.Loading'),
			wxshareTitle: '', //分享标题
			wxshareContent: '', //分享标题
			uploadSuces: '', //分享标题
			URLObj: {},
			examBrowserUUID: '', // 浏览器唯一标识
			wxShareVisible: false,
			quotaList: [],
			quotaListactive: [],
			// 配额已满提示
			quotaTips: '',
			quotaId: '', // 配额id
			endMsg: '', // 结束语
			endPageAdvanceMsg: '', // 结束语
			endPageNormalMsg: '', // 结束语
			sampleParamList: []
		};
	},
	computed: {
		...mapState(['wjQuestionTypeArr', 'headers']),
		// 隐藏收集配额试题列表
		quotatypeList() {
			console.log(this.quotaList);
			let data = this.quotaList.filter(info => {
				return info.ruleType == 2;
			});
			return data;
		},
	},
	watch: {
		styleData: {
			handler(vnew, vold) {
				this.style.appearance = this.styleData.appearance; //pc 外观
				this.stylePhone.appearancePhone = this.styleData.appearancePhone; //手机外观
				this.style.subjectColor = this.styleData.subjectColor;
				this.stylePhone.subjectColor = this.styleData.subjectColor;
			},
			deep: true,
			immediate: true
		}
	},
	created() {
		this.submitloading = this.$t('UserAnswer.Loading');
		this.loadingInstance = this.$loading({
			lock: true,
			text: this.submitloading,
			spinner: 'el-icon-loading',
			background: 'hsla(0,0%,100%,.9)'
		});
		this.URLObj = this.getUrl(window.location.href);
		console.log('this.URLObj', this.URLObj)
		console.log('this.$route.query.id', this.$route.query.id)
		if (this.URLObj?.id) {
			this.id = this.URLObj.id;
		} else {
			this.id = sessionStorage.getItem('wid') || this.$route.query.id;
		}
		if (this.URLObj?.sampleId) {
			this.underwayId = this.URLObj.sampleId;
		}

		// 考试次数限制 本地存储uuid 传给后端去判断
		if (localStorage.getItem(`${this.id}UUID`)) {
			this.examBrowserUUID = localStorage.getItem(`${this.id}UUID`);
		} else {
			localStorage.setItem(`${this.id}UUID`, UUID());
			this.examBrowserUUID = localStorage.getItem(`${this.id}UUID`);
		}
		this.getPaper()
		// console.log(this.isPreviewPc)
		if (!this.styleData.subjectColor) {
			this.loadAppear();
		} else {
			this.style.appearance = this.styleData.appearance; //pc 外观
			this.stylePhone.appearancePhone = this.styleData.appearancePhone; //手机外观
			this.style.subjectColor = this.styleData.subjectColor;
			this.stylePhone.subjectColor = this.styleData.subjectColor;
		}
	},
	mounted() {},
	methods: {
		getPaper() {
			if (this.isPreviewPc == 1) {
				this.isPc = false;
				// 在设计页面没有主动保存的情况下 请求数据接口适当延迟请求
				if(this.isBank) {
					this.getBankData()
				} else{
					setTimeout(() => {
						this.getPreviewData();
					}, 1000);
				}
			} else if (this.isPreviewPc == 2) {
				this.isPc = true;
				if(this.isBank) {
					this.getBankData()
				} else{
					if (this.$route.query.yq) {
						// 引入模板
						setTimeout(() => {
							this.getTemplateData();
						}, 1000);
					} else {
						setTimeout(() => {
							this.getPreviewData();
						}, 1000);
					}
				}
			} else {
				this.isPc = this.$functions.isPC()
				//  this.getdataJson() // 使用本地试题结构
				// 考试与考试预览都使用该接口获取试题
				this.getData()
			}
		},
        getBankData() {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankGetQuess}?id=${this.id}`,
                method: "GET",
                cb(res) {
					that.loadingInstance.close();
                    // console.log(res)
                    if (res.code == '0') {
                        that.code = 0
                        // that.data = JSON.parse(res.resultBody.paperjson)
                        let paper = JSON.parse(res.resultBody.paperjson)
                        that.data.questionsList = paper.questionsList.map((info) => {
                            if (that.$functions.isJSON(info)){
                                return JSON.parse(info)
                            }
                            return info
                        })
						
						that.data.title = paper.title;
						that.data.depict = paper.depict;
						
						SetAnswer('', that.data.questionsList, that.$refs)
						that.setDepict()
                    }
                },
            };
            this.$util.request(params);
        },
		shareToWX() {
			this.wxShareVisible = true;
			let url = window.location.href;
			this.$nextTick(() => {
				QrCode.toCanvas(this.$refs.qrCodeImg, url, {
					width: 200,
					height: 200
				});
			});
		},
		loadAppear() {
			//外观内容
			let that = this;
			// console.log('输出wid', id);
			let params = {
				that: this,
				url: `${this.$config.service.selectQuestionnaire}`,
				method: 'POST',
				data: {
					id: that.id
				},
				cb(res) {
					if (res.code == 0) {
						that.style.appearance = res.resultBody.appearance; //pc 外观
						that.stylePhone.appearancePhone = res.resultBody.appearancePhone; //手机外观
						that.style.subjectColor = res.resultBody.subjectColor;
						that.stylePhone.subjectColor = res.resultBody.subjectColor;
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		getTemplateData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionnairePreview}?id=${this.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					that.loadingInstance.close();
					console.log('引入模板', res);
					if (res.code == 0) {
						if (res.resultBody != '') {
							let paperjson = JSON.parse(res.resultBody.paperjson);
							that.data.questionsList = paperjson.questionsList;
							that.data.title = paperjson.title;
							that.data.depict = paperjson.depict;
							that.code = 0;
							// 每个题型用户的答题字段在这里就开始设置userAnswer、userAnswerArr
							SetAnswer('', that.data.questionsList, that.$refs);
							that.setDepict()
						} else {
							that.data.questionsList = [];
							that.data.title = res.resultBody.wjTitle;
						}
					}
				}
			};
			this.$util.request(params);
		},
		getPreviewData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionlist}?id=${this.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					that.loadingInstance.close();
					// console.log(res);
					if (res.code == 0) {
						if (res.resultBody.tbExamPaper != '') {
							let paperjson = JSON.parse(res.resultBody.tbExamPaper.paperjson);
							that.data.questionsList = paperjson.questionsList;
							that.data.title = paperjson.title;
							that.data.depict = paperjson.depict;
							that.code = 0;
							// 每个题型用户的答题字段在这里就开始设置userAnswer、userAnswerArr
							SetAnswer('', that.data.questionsList, that.$refs);
							that.setDepict()
						} else {
							that.data.questionsList = [];
							that.data.title = res.resultBody.wjTitle;
						}
					}else{
						that.wjPreview()
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		wjPreview(){
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examPaperpreview}?id=${this.id}`,
				method: 'POST',
				data: {},
				cb(res) {
					that.loadingInstance.close();
					console.log(res);
					if (res.code == 0) {
						if (res.resultBody.tbExamPaper != '') {
							let paperjson = JSON.parse(res.resultBody.tbExamPaper.paperjson);
							that.data.questionsList = paperjson.questionsList;
							that.data.title = paperjson.title;
							that.data.depict = paperjson.depict;
							that.code = 0;
							// 每个题型用户的答题字段在这里就开始设置userAnswer、userAnswerArr
							SetAnswer('', that.data.questionsList, that.$refs);
							that.setDepict()
						} else {
							that.data.questionsList = [];
							that.data.title = res.resultBody.wjTitle;
						} 
					}
				}
			};
			this.$util.request(params);
		},
		setDepict(){
			// 处理问卷描述中的图片
			this.data.depict = this.imgTagAddStyle(this.data.depict)
		},
		getUrl(url) {
			// 先获取href问号以及问号后的内容
			if (url) {
				url = url.substr(url.indexOf('?'));
			} else {
				url = window.location.href;
			}
			//判断是否含有问号，有则说明含有参数
			if (url.indexOf('?') !== -1) {
				var str = url.substr(1);
				var strs = str.split('&');
				var obj = new Object();
				// console.log(str)
				// console.log(strs)
				for (var i = 0; i < strs.length; i++) {
					if (strs[i].split('=')[1].indexOf('#') != -1) {
						obj[strs[i].split('=')[0]] = strs[i].split('=')[1].split('#')[0];
					} else {
						obj[strs[i].split('=')[0]] = strs[i].split('=')[1];
					}
				}
				return obj;
			}
			return null;
		},
		// 是否为微信浏览器
		isWeiXin() {
			//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
			var ua = window.navigator.userAgent.toLowerCase();
			// alert(JSON.stringify(ua))
			//通过正则表达式匹配ua中是否含有MicroMessenger字符串
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true;
			} else {
				return false;
			}
		},
		// 微信卡片分享
		createWxSignature() {
			let that = this;
			let appId = '';
			let timestamp = ''; // 必填，生成签名的时间戳
			let nonceStr = ''; // 必填，生成签名的随机串
			let signature = ''; // 必填，签名
			let title = that.$functions.filterHtmlTag(that.wxshareTitle); // 分享标题
			let desc = that.$functions.filterHtmlTag(that.wxshareContent); // 分享描述
			let link = `${this.$config.url}/#/userAnswer?id=${this.id}`; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
			let imgUrl = that.uploadSuces; // 分享图标
			console.log('link', link)
			let url = `${this.$config.service.createSignature}?url=${encodeURIComponent(location.href.split('#')[0])}`;
			console.log('url', url);
			$.ajax({
				type: 'GET',
				url: url,
				dataType: '',
				success(res) {
					// alert(`微信信息:${JSON.stringify(res)}`)
					console.log('微信信息', res);
					console.group('调用微信分享接口api');
					appId = res.resultBody.appId; // 必填，公众号的唯一标识
					timestamp = res.resultBody.timestamp; // 必填，生成签名的时间戳
					nonceStr = res.resultBody.noncestr; // 必填，生成签名的随机串
					signature = res.resultBody.signature; // 必填，签名

					// alert(`res.code:${res.code}`)
					if (res.code == 0) {
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: appId, // 必填，公众号的唯一标识
							timestamp: timestamp, // 必填，生成签名的时间戳
							nonceStr: nonceStr, // 必填，生成签名的随机串
							signature: signature, // 必填，签名
							jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
						});
						wx.ready(function() {
							//需在用户可能点击分享按钮前就先调用
							console.group('微信 ready');
							wx.updateAppMessageShareData({
								title: title, // 分享标题
								desc: desc, // 分享描述
								link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
								imgUrl: imgUrl, // 分享图标
								success: function() {
									// alert("分享成功")
									console.log('分享成功');
								}
							});
							wx.updateTimelineShareData({
								title: title, // 分享标题
								desc: desc, // 分享描述
								link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
								imgUrl: imgUrl, // 分享图标
								success: function() {
									// alert("分享成功")
									console.log('分享成功');
								}
							});
							console.groupEnd();
						});

						wx.error(function(res) {
							// alert("微信错误")
							console.group('微信错误');
							// console.log(res)
							console.groupEnd();
							// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
						});
					}
					// console.log(res);
					console.groupEnd();
				}
			});
		},
		// 判断浏览器是否处于全屏状态
		checkFull() {
			//判断浏览器是否处于全屏状态 （需要考虑兼容问题）
			//火狐浏览器
			var isFull =
				document.mozFullScreen ||
				document.fullScreen ||
				//谷歌浏览器及Webkit内核浏览器
				document.webkitIsFullScreen ||
				document.webkitRequestFullScreen ||
				document.mozRequestFullScreen ||
				document.msFullscreenEnabled;
			if (isFull === undefined) {
				isFull = false;
			}
			return isFull;
		},
		// 全屏事件
		handleFullScreen() {
			let element = document.documentElement;
			if (this.isFullFlag) {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}

				//     // this.isFullFlag = !this.isFullFlag;
			} else {
				if (element.RequestFullScreen) {
					element.RequestFullScreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullscreen) {
					// IE11
					element.msRequestFullscreen();
				}
			}
		},
		handleonmousedown(state) {
			// state 1 考试结束 超时强制交卷
			let timer;
			if (this.answerExceedTimer) {
				clearTimeout(this.answerExceedTimer);
			}
			if (state == 1) {
				timer = this.quanxian.examrExceedTime;
			} else {
				timer = this.quanxian.answerExceedTime;
			}
			this.answerExceedTimer = setTimeout(() => {
				// 提交试卷接口
				console.log('交卷');

				if (state == 1) {
					this.submit();
				}
				clearTimeout(this.answerExceedTimer);
			}, timer * 1000);
		},
		continueBeforClose() {
			this.continueDialogVisible = false;
			if (this.submitCountdownTimer) {
				clearInterval(this.submitCountdownTimer);
			}
		},
		// 切屏检测
		cutScreenCheck() {
			window.addEventListener('resize', this.resizeMonitor);
			window.addEventListener('blur', this.documentBlur);
			window.onresize = () => {
				if (!this.checkFull()) {
					// 退出全屏后要执行的动作
					if (this.cutScreenNum < this.quanxian.cutScreenNum) {
						this.resizeMonitor();
						this.isFullFlag = false;
					}
				} else {
					this.isFullFlag = true;
				}
			};
		},
		// 清除监听切屏事件
		cutScreenCheckRemove() {
			this.cutScreenNum = 0;
			window.removeEventListener('resize', this.resizeMonitor);
			window.removeEventListener('blur', this.documentBlur);
		},
		documentBlur() {
			this.cutScreenNum++;
			this.cutScreenDialogVisible = true;
			if (this.cutScreenNum == this.quanxian.cutScreenNum) {
				this.submit();
			}
		},
		resizeMonitor() {
			if (!this.checkFull()) {
				if (this.cutScreenDialogVisible == false) {
					this.cutScreenDialogVisible = true;
					this.cutScreenNum++;
				}
			}

			if (this.cutScreenNum == this.quanxian.cutScreenNum) {
				this.submit();
			}
		},
		// 触发是否继续答题弹窗
		cutScreenContinue() {
			if (this.isFullFlag == false) {
				this.handleFullScreen();
			}
			this.cutScreenDialogVisible = false;
		},
		userLoginWX() {
			// alert(`获取微信info:userLoginWX`)
			this.wxLogin = false;
			this.WXcode = this.URLObj?.code;
			// console.log(url)
			// this.WXcode = '091VrFFa1PRJzD0XhmGa1llz6D1VrFFO'
			if (this.WXcode == null || this.WXcode === '') {
				// 如果没有code，则去请求
				window.location.href = this.snsapiUserinfoUrl()
			}
		},
		
        // 获取微信静默微信登录code
        loginWX() {
            let state = JSON.stringify({
                    id: this.id
                })
            this.WXcode = this.URLObj.code
			
            // alert(`state：${state}`)
            // alert(`微信code:${this.WXcode}`)
            if (this.WXcode == null || this.WXcode === '') { // 如果没有code，则去请求
                // alert(`未获取到code`)
                window.location.href = this.snsapiBaseUrl()
            } else {
                // alert(`已获取到code`)
                this.getOpenId()
            }
        },
		// 静默授权获取openid
		snsapiBaseUrl() {
			let redirect_uri = `http://wx.outh.ai-learning.net?sys=${this.$functions.getWXSys()}&id=${this.id}#/userAnswer`;
            // console.log(`redirect_uri:${redirect_uri}`)
            // alert(`未编码：${redirect_uri}`)
            redirect_uri = encodeURIComponent(redirect_uri)
			return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe56ce182843a7957&response_type=code&scope=snsapi_base&redirect_uri=${redirect_uri}#wechat_redirect`
		},
		// 用户授权获取用户的基本信息
		snsapiUserinfoUrl() {
			
			let redirect_uri = `http://wx.outh.ai-learning.net?sys=${this.$functions.getWXSys()}&id=${this.id}#/userAnswer`;
			redirect_uri = encodeURIComponent(redirect_uri);
			return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe56ce182843a7957&response_type=code&scope=snsapi_userinfo&redirect_uri=' +
				redirect_uri +
				'#wechat_redirect'
		},
        getOpenId() {
            // alert('获取openid方法')
            // console.log( `${this.$config.service.WXgetOpenId}?code=${this.WXcode}`)
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.WXgetOpenId}?code=${this.WXcode}`,
                method: "get",
                cb(res) {
                    // alert(`res.code:${res.code}`)
                    // alert(`openid:${res.resultBody.openId}`)
                    if (res.code == '0') {
                        that.openId = res.resultBody.openId
                        // ofoPW585tvQHnIvlUSFfTtZSvyVY
                        // alert(`that.id:${that.id}`)
                        that.getData()
                    } else {
						// 获取code失败
						that.WXcode = ''
                		window.location.href = that.snsapiBaseUrl()
					}
                },
            };
            
            params.isnologin = true
            this.$util.request(params);
        },
		getWXuserByWeChatLogin() {
			// alert(`获取微信getWXuserByWeChatLogin`)
			// alert(`this.WXcode${this.WXcode}`)
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.WXuserByWeChatLogin}?code=${this.WXcode}`,
				method: 'get',
				cb(res) {
					// console.log(res);
					localStorage.setItem('token', res.resultBody.token);
					if (res.code == '0') {
						that.openId = res.resultBody.openId;
						that.getData();
					} else {
						// 获取code失败
						that.WXcode = ''
                		window.location.href = that.snsapiUserinfoUrl()
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		// 获取参数 带#
		getQueryStringhash(key) {
			let after = window.location.hash.split('?')[1];
			if (after) {
				let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
				let r = after.match(reg);
				if (r != null) {
					return decodeURIComponent(r[2]);
				} else {
					return null;
				}
			}
		},
		answerAgain() {
			this.data = this.noAnswerData;
			if (localStorage.getItem(this.id)) {
				localStorage.removeItem(this.id);
			}
            this.isStaging = true
			this.dialogVisible = false;
		},
		imgTagAddStyle(htmlstr){
			//正则匹配所有img标签
			var regex0 = new RegExp("(i?)(\<img)([^\>]+\>)","gmi");
			// console.warn(regex0.test(htmlstr))
			if (regex0.test(htmlstr)) {
				//正则匹配不含style="" 或 style='' 的img标签
				var regex1 = new RegExp("(i?)(\<img)(?!(.*?style=['\"](.*)['\"])[^\>]+\>)","gmi");
				//给不含style="" 或 style='' 的img标签加上style=""
				htmlstr = htmlstr.replace(regex1, "$2 style=\"\"$3");
				// console.log("增加style=\"\"后的html字符串："+htmlstr);
				//正则匹配含有style的img标签
				var regex2 = new RegExp("(i?)(\<img.*?style=['\"])([^\>]+\>)","gmi");
				//在img标签的style里面增加css样式(这里增加的样式：display:block;max-width:100%;height:auto;border:5px solid red;)
				htmlstr = htmlstr.replace(regex2, "$2max-width:100%;height:auto;$3");
				// console.log("在img标签的style里面增加样式后的html字符串："+htmlstr);
			}
			return htmlstr;
		},
		
		// 替换题目中的样本信息
		setSampleParam(name) {
			const reg = /(@@Sample\[).*?(\]@@)/g
			let arr = name.match(reg)
			if (arr) {
				arr.forEach((info) => {
					console.log(info)
					this.sampleParamList.forEach(val => {
						if (name.indexOf(info) !== -1 && info.indexOf(val.chfieldName) !== -1) {
							name = name.replace(info, val.value)
						}
					})
				})
			}
			return name
		},
		getData(state) {
			let data = {
				surveyId: this.id,
				id: this.underwayId
			};
			if (this.openId) {
				data.wxOpenid = this.openId;
			}
			if (this.password) {
				data.answerPassword = this.password;
			}
			if (this.examBrowserUUID) {
				data.browseOnlyId = this.examBrowserUUID;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryPaperConfig}`,
				method: 'POST',
				data: data,
				cb(res) {
					that.loadingInstance.close();
					that.code = res.code;
					that.message = res.message;
					switch (res.code) {
						case '2001': // 密码型
							that.showPassword = true;
							if (state == 1) {
								// that.$message.error('请输入密码')
								that.passwordError = true;
								that.passwordErrorTip = res.message;
							}
							break;
						case '2000': // 密码错误
							that.passwordError = true;
							that.passwordErrorTip = res.message;
							break;
						case '1001': // 考试已结束 （错误码）
							break;
						case '2002': // 考试未开始
							that.isStartTime = false;
							that.examStartTime = res.resultBody.examStartTime;
							that.data.title = res.resultBody.questionnaire.wjTitle;
							that.tipTitle = that.$functions.filterHtmlTag(res.resultBody.questionnaire.wjTitle);
							// that.$message.error(res.message)
							break;
						case '2004': // 是否需要微信登录
							// alert(that.isPc)
							if (!that.isPc) {
								that.isWX = true;
								/*
								 *getWxName // (需要微信登录)状态
								 */
								// alert('是否需要微信登录')
								// if (res.resultBody.getWxName == 1) {
									// alert('需要微信登录')
									// 如果有 说明微信登录以获取用户信息
									if (that.URLObj?.code) {
										that.WXcode = that.URLObj.code;
										that.getWXuserByWeChatLogin();
									} else {
										that.wxLogin = true;
									}
								// }else {
								// 	// alert('loginWX微信')
								// 	that.loginWX()
								// 	// 返回openId后在请求试题结构接口
								// }
								// console.log(that.wxLogin);
								// 返回openId、token后在请求试题结构接口
							} else {
								that.getWxQrCode();
								that.isWX = false;
							}
							break;
						case '0':
							// console.log('111111111111111', res.resultBody.questionnaire);
							// alert(JSON.stringify(res.resultBody.questionnaire))
							that.quanxian = res.resultBody.questionnaire;
							console.log('that.quanxian :>> ', that.quanxian);
							that.quotaList = res.resultBody.questionnaireNewQuotaList;
							that.wxshareTitle = res.resultBody.questionnaire.wxshareTitle;
							that.wxshareContent = res.resultBody.questionnaire.wxshareContent;
							let { wxsharePicture } = res.resultBody.questionnaire;
							that.uploadSuces = wxsharePicture && wxsharePicture != 'aixuelogo.png' ? wxsharePicture : that.$logo;
							let paperjson = JSON.parse(res.resultBody.tbExamPaper.paperjson);
							that.data.questionsList = paperjson.questionsList;
							that.data.title = paperjson.title;
							that.data.depict = paperjson.depict;
							that.endPageAdvanceMsg = paperjson.endPageAdvanceMsg;
							that.endPageNormalMsg = paperjson.endPageNormalMsg;
							that.tipTitle = that.$functions.filterHtmlTag(res.resultBody.questionnaire.wjTitle);

							that.list = that.data.questionsList;
							that.underwayId = res.resultBody.id;
							localStorage.setItem('underwayId', res.resultBody.id);
							// 微信分享
							if (that.isWeiXin()) {
								that.createWxSignature();
							}
							// 考试次数限制
							if (localStorage.getItem(`${that.id}UUID`) && that.quanxian.pcLimit != 1) {
								localStorage.removeItem(`${that.id}UUID`);
							}
							// 样本参数信息
							that.sampleParamList = res.resultBody.customFields
							
							// 设置试题随机条件
							if (that.quanxian.randomJson) {
								that.data.questionsList = randomSelection(that.data.questionsList, that.quanxian.randomJson)
							}
							
							// 每个题型用户的答题字段在这里就开始设置userAnswer、userAnswerArr
							
							SetAnswer(res.resultBody.result, that.data.questionsList, that.$refs);
							that.data.depict = that.setSampleParam(that.data.depict)
							that.setDepict()
                        	that.noAnswerData = JSON.parse(JSON.stringify(that.data))
							// 是否开启暂存
							if(that.quanxian.isStaging == 1) {
								that.getStaging()
							}
							if (that.quanxian.cutScreenStatus == 1) {
								{
									that.$nextTick(() => {
										that.cutScreenCheck();
									});
								}
							}
							break;
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		// 获取暂存的数据
		getStaging() {
			if (localStorage.getItem(this.id)) {
				this.data.questionsList = JSON.parse(localStorage.getItem(this.id)).questionsList
				this.answeredNumber = this.answeredNum(this.data.questionsList)
				
				this.dialogVisible = this.answeredNumber > 0 ? true : false
			} else{
				this.isStaging = true
			}
		},
		// 暂存
		setStaging() {
			localStorage.setItem(this.id, JSON.stringify({
				questionsList: this.data.questionsList,
				underwayId: this.underwayId // 样本id
			}))
		},
		// 获取当前地址的二维码
		getWxQrCode() {
			// console.log(location.href)
			let url = location.href;
			// console.log(url);
			this.$nextTick(() => {
				QrCode.toCanvas(this.$refs.qrCodeImg, url, {
					width: 200,
					height: 200
				});
			});
		},
		answeredNum(list) {
			let num = 0;
			list.forEach(info => {
				if ((info.userAnswerArr && info.userAnswerArr.length > 0) || info.userAnswer) {
					num++;
				}
			});
			// console.log(num)
			return num;
		},
		// 查看统计
		viewStatistics() {
			this.$message({
				message: this.$t('UserAnswer.StatisticsPageToBeImproved'),
				type: 'warning'
			});
		},
		async DrawingUpQiniu(userAnswer) {
			return new Promise(async resolve => {
				let blob = this.dataURLtoBlob(userAnswer);
				let file = new File([blob], 'file' + UUID(), {
					type: blob.type,
					lastModified: Date.now()
				});
				// console.log(file)
				var formData = new FormData();
				formData.append('file', file);
				formData.append('biz', 'upDataWj');
				$.ajax({
					url: `${this.$config.service.uploadApi}`,
					type: 'POST',
					data: formData,
					miniType: 'multipart/form-data',
					contentType: false,
					processData: false,
					success: await function(data) {
						// console.log(data.key)
						resolve(data.message);
					},
					error: ()=> {
						alert(this.$t('UserAnswer.UploadFailed'));
					}
				});
			});
		},
		// base64字符串转换为Blob
		dataURLtoBlob(dataURI) {
			let byteString = atob(dataURI.split(',')[1]);
			let mimeString = dataURI
				.split(',')[0]
				.split(':')[1]
				.split(';')[0];
			let ab = new ArrayBuffer(byteString.length);
			let ia = new Uint8Array(ab);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new Blob([ab], { type: mimeString });
		},

		// 验证配额
		// async doVerifyQuota() {
		// 	let result;
		// 	for (let i in this.data.questionsList) {
		// 		const promise = await new Promise((resolve, reject) => {
		// 			this.quotaCollection(this.data.questionsList[i], resolve);
		// 		});
		// 		if (promise == true) {
		// 			result = 14;
		// 			break;
		// 		}
		// 	}
		// 	return result;
		// },
		// quotaCollection(data, resolve) {
		// 	if (this.quotatypeList.length == 0) {
		// 		resolve();
		// 	}
		// 	for (let i in this.quotatypeList) {
		// 		if (this.quotatypeList[i].rlueConditionOne == data.qid) {
		// 			// 当前选中的答案为配额第一项
		// 			if (data.userAnswer) {
		// 				// 当前试题答案为字符串
		// 				this.quotaAnswer(this.quotatypeList[i], data.userAnswer, 1, resolve);
		// 			} else if (data.userAnswerArr) {
		// 				// 当前试题答案为数组对象
		// 				this.quotaAnswerArr(this.quotatypeList[i], data.userAnswerArr, 1, resolve);
		// 			}
		// 		} else if (this.quotatypeList[i].rlueConditionTwo == data.qid) {
		// 			// 当前选中的答案为配额第二项
		// 			if (data.userAnswer) {
		// 				// 当前试题答案为字符串
		// 				this.quotaAnswer(this.quotatypeList[i], data.userAnswer, 2, resolve);
		// 			} else if (data.userAnswerArr) {
		// 				// 当前试题答案为数组对象
		// 				this.quotaAnswerArr(this.quotatypeList[i], data.userAnswerArr, 2, resolve);
		// 			}
		// 		}
		// 	}
		// },
		//IF userAnswer
		// quotaAnswer(info, answer, number, resolve) {
		// 	// 条件列表
		// 	for (let i in info.questionnaireNewQuotaDetailsList) {
		// 		let data = info.questionnaireNewQuotaDetailsList[i];
		// 		// optionOneCondition 配额选项1 、optionTwoCondition配额选项2
		// 		// console.log(data.quotaNumber);
		// 		if (data.quotaNumber > 0) {
		// 			if (number == 1 && answer == data.optionOneCondition) {
		// 				if (info.ruleConditionTwoType == 1) {
		// 					// 样本配额
		// 					console.warn('立即提交 state为76');
		// 					this.getQuotaInfo(data.id, resolve);
		// 					break;
		// 				} else {
		// 					this.validateQuota(info, data, 1, resolve);
		// 					break;
		// 				}
		// 			} else if (number == 2 && answer == data.optionTwoCondition) {
		// 				if (info.ruleConditionOneType == 1) {
		// 					// 样本配额
		// 					console.warn('立即提交 state为77');
		// 					this.getQuotaInfo(data.id, resolve);
		// 				} else {
		// 					this.validateQuota(info, data, 2, resolve);
		// 					break;
		// 				}
		// 			}
		// 		}
		// 	}
		// },
		// //IF userAnswerArr
		// quotaAnswerArr(info, answerArr, number, resolve) {
		// 	// number: 配额中的第几个试题
		// 	// info: typelistinfo
		// 	// 条件列表
		// 	for (let i in info.questionnaireNewQuotaDetailsList) {
		// 		let data = info.questionnaireNewQuotaDetailsList[i];
		// 		// optionOneCondition 配额选项1 、optionTwoCondition配额选项2
		// 		// console.log(data.quotaNumber);
		// 		if (data.quotaNumber > 0) {
		// 			if (number == 1 && answerArr.indexOf(data.optionOneCondition) !== -1) {
		// 				if (info.ruleConditionTwoType == 1) {
		// 					// 样本配额
		// 					console.warn('立即提交 state为78');
		// 					this.getQuotaInfo(data.id, resolve);
		// 					break;
		// 				} else {
		// 					this.validateQuota(info, data, 1, resolve);
		// 					break;
		// 				}
		// 			} else if (number == 2 && answerArr.indexOf(data.optionTwoCondition) !== -1) {
		// 				if (info.ruleConditionOneType == 1) {
		// 					// 样本配额
		// 					console.warn('立即提交 state为79');
		// 					this.getQuotaInfo(data.id, resolve);
		// 				} else {
		// 					this.validateQuota(info, data, 2, resolve);
		// 					break;
		// 				}
		// 			}
		// 		}
		// 	}
		// },
		// 获取配额列表
		// getQuotaInfo(id, resolve) {
		// 	let that = this;
		// 	let params = {
		// 		that: this,
		// 		url: `${this.$config.service.verifyQuota}`,
		// 		method: 'POST',
		// 		data: {
		// 			id: id
		// 		},
		// 		cb(res) {
		// 			// console.log(res);
		// 			if (res.code == 0) {
		// 				if (res.resultBody == 1) {
		// 					resolve(true);
		// 				}
		// 			}
		// 		}
		// 	};
		// 	params.isnologin = true;
		// 	this.$util.request(params);
		// },
		// 验证配额
		// validateQuota(obj, objItem, number, resolve) {
		// 	// number：配中的第几个选项
		// 	// console.log(this.quotaListactive);
		// 	let resilt = false;
		// 	for (let el in this.quotaListactive) {
		// 		if (this.quotaListactive[el].id == obj.id) {
		// 			// 可以确定是哪个配额
		// 			for (let quotaIndex in this.quotaListactive[el].questionnaireNewQuotaDetailsList) {
		// 				let val = this.quotaListactive[el].questionnaireNewQuotaDetailsList[quotaIndex];
		// 				if (val.quotaNumber > 0) {
		// 					if (objItem.optionTwoCondition) {
		// 						if (objItem.optionTwoCondition == val.optionTwoCondition) {
		// 							if (number == 1) {
		// 								if (obj.rlueConditionTwo) {
		// 									for (let j in this.data.questionsList) {
		// 										if (this.data.questionsList[j].userAnswer && this.data.questionsList[j].userAnswer == val.optionTwoCondition) {
		// 											console.warn('立即提交 state为71');
		// 											this.getQuotaInfo(val.id, resolve);
		// 											resilt = true;
		// 											break;
		// 										} else if (
		// 											this.data.questionsList[j].userAnswerArr &&
		// 											this.data.questionsList[j].userAnswerArr.indexOf(val.optionTwoCondition) !== -1
		// 										) {
		// 											console.warn('立即提交 state为72');
		// 											this.getQuotaInfo(val.id, resolve);
		// 											resilt = true;
		// 											break;
		// 										}
		// 									}
		// 								}
		// 							} else if (number == 2) {
		// 								// console.log('obj');
		// 								// console.log(obj);
		// 								if (obj.rlueConditionOne) {
		// 									for (let j in this.data.questionsList) {
		// 										if (this.data.questionsList[j].userAnswer && this.data.questionsList[j].userAnswer == val.optionOneCondition) {
		// 											console.warn('立即提交 state为74');
		// 											this.getQuotaInfo(val.id, resolve);
		// 											resilt = true;
		// 											break;
		// 										} else if (
		// 											this.data.questionsList[j].userAnswerArr &&
		// 											this.data.questionsList[j].userAnswerArr.indexOf(val.optionOneCondition) !== -1
		// 										) {
		// 											console.warn('立即提交 state为75');
		// 											this.getQuotaInfo(val.id, resolve);
		// 											resilt = true;
		// 											break;
		// 										}
		// 									}
		// 								}
		// 							}
		// 						}
		// 					} else {
		// 						console.warn('立即提交 state为73');
		// 						this.getQuotaInfo(objItem.id, resolve);
		// 						resilt = true;
		// 						break;
		// 					}
		// 				}
		// 				if (resilt) {
		// 					break;
		// 				}
		// 			}
		// 			if (resilt) {
		// 				break;
		// 			}
		// 		}
		// 		if (resilt) {
		// 			break;
		// 		}
		// 	}
		// },
		// 交卷
		/**
		 * @param answerState 答题状态 6完成 14配额已满 4问卷无效
		 * @param quotaTips 交卷后提示
		 * @param quotaId 配额id
		 */
		async submit(answerState, quotaTips) {
			if (this.isPreviewPc == 0) {
				this.submitloading = this.$t('UserAnswer.Submitting');
                this.loadingInstance = this.$loading({
                    lock: true,
                    text: this.submitloading,
                    spinner: 'el-icon-loading',
                    background: 'hsla(0,0%,100%,.9)'
                });
				let answerList = await GetAnswerList(this.data.questionsList);
				// console.log(answerList)
				if (this.quotatypeList.length > 0) {
					answerState = await doVerifyQuota(this.data.questionsList, this.quotatypeList);
					console.log('answerState :>> ', answerState);
				}
				// console.log('答题结果--------');
				// console.log(answerList);
				// console.log(JSON.stringify(answerList));
				// console.log('答题结果--------');
				if (!this.underwayId && localStorage.getItem('underwayId')) {
					this.underwayId = localStorage.getItem('underwayId');
				}
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.saveAnswer}`,
					method: 'POST',
					data: {
						surveyId: this.id,
						result: JSON.stringify(answerList),
						id: this.underwayId,
						answerState: answerState ? answerState : 6
					},
					cb(res) {
                        that.loadingInstance.close();
						// console.log(res)
						if (res.code == '0') {
							if (answerState == 14 || answerState == 6 || answerState == 3) {
								if (quotaTips) {
									that.quotaTips = quotaTips;
								}
							}
							that.endMsg = answerState == 4 ? that.endPageAdvanceMsg : that.endPageNormalMsg
							that.dialogthinkVisible = true;
							// 暂存
							if (answerState == 3) {
								that.setStaging()
							} else if (localStorage.getItem(that.id)) {
								localStorage.removeItem(that.id);
							}
							if (that.continueDialogVisible == true) {
								that.continueDialogVisible = false;
							}
							// 开启（每台设备答题次数）
							// if (that.quanxian.pcPhoneAnswerNumState == 1) {
							//     let num = localStorage.getItem(`${that.id}Num`)
							//     localStorage.setItem(`${that.id}Num`, parseInt(num) + 1)
							// }
							if (that.quanxian.ifCustomJump == 1) {
								// 开启跳转
								if (that.quanxian.customJump == 1) {
									// 跳转链接
									window.location.href= that.quanxian.skipUrl;
								}
							}
							that.continueBeforClose();
							that.cutScreenCheckRemove();
						}
					}
				};
				params.isnologin = true;
				this.$util.request(params);
			} else {
				this.$notify({
					title: this.$t('UserAnswer.Prompt'),
					message: this.$t('UserAnswer.TheAnswerIsNotRecorded')
				});
				let answerList = await GetAnswerList(this.data.questionsList);

				// console.log('答题结果--------');
				// console.log(answerList);
				// console.log(this.data.questionsList);
				// console.log('答题结果--------');
			}
		},
		confirmPassword() {
			this.getData(1);
		},
		// 试卷随机
		shuffle(array) {
			let lists = [],
				arr = [],
				res = [],
				index = 0;
			array.forEach((info, index) => {
				if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
					arr.push(info);
					lists.push(arr);
					arr = [];
				} else {
					arr.push(info);
				}
				if (index == array.length - 1) {
					lists.push(arr);
				}
			});
			lists.forEach(info => {
				info = this.suiji(info);
				res.push(...info);
			});
			res.forEach(item => {
				// console.log(wjQuestionTypeArr.indexOf(item.questionsTypeId) != -1)
				if (this.wjQuestionTypeArr.indexOf(item.questionsTypeId) != -1) {
					item.quesIndex = index;
					index++;
				}
			});
			return res;
		},
		suiji(array) {
			let res = [],
				random,
				userInfoArr = [],
				quesArr = [],
				pageArr = [];
			array.forEach(info => {
				if (info.questionsTypeId === 600) {
					userInfoArr.push(info);
				} else if (info.questionsTypeId === 402 || info.questionsTypeId === 404) {
					pageArr.push(info);
				} else {
					quesArr.push(info);
				}
			});
			while (quesArr.length > 0) {
				random = Math.floor(Math.random() * quesArr.length);
				res.push(quesArr[random]);
				quesArr.splice(random, 1);
			}
			return [...userInfoArr, ...res, ...pageArr];
		}
	},

	beforeDestroy() {
		this.cutScreenCheckRemove();
	}
};
</script>
<style lang="scss" scoped>
.content {
	width: 100%;
	min-height: 100vh;
	background-color: #fff;
	margin: auto;
	&_row {
		// width: 1400px;
		// width: 74%;
		width: 100%;
		min-height: 100vh;
		padding: 50px 0 30px 0;
		margin-left: auto !important;
		margin-right: auto !important;
		background: aliceblue;
		background-size: cover;
		background-repeat: no-repeat;

		.content_center {
			// background: #fff;
			padding: 0 0 50px 0 !important;
			.header {
				border-radius: 2px !important;
				box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
				.title {
					font-weight: 650;
					font-style: normal;
					font-size: 22px;
					color: #797979;
					text-align: center;
				}
			}
			.ques_box {
				padding: 0 50px 50px 50px;
				font-weight: 650;
				font-style: normal;
				font-size: 15px;
				.list {
					margin-top: 50px;
				}
				.ques_list {
					.ques_list_item {
						margin-top: 10px;
					}
					.title {
						width: 100px;
					}
					.input {
						width: 220px;
					}
				}
			}
			.pages,
			.footer-box {
				text-align: center;
			}
		}
	}
	.isNotStartTime,
	.submittedSuccess {
		text-align: center;
		background-color: #fff;
		padding: 70px;
		margin-top: 100px;
		.title {
			font-weight: 650;
			font-size: 23px;
			color: #169bd5;
		}
		.tips {
			font-size: 17px;
			background-color: rgba(234, 242, 248, 1);
			margin: 50px 135px;
			line-height: 50px;
		}
		.date {
			font-size: 17px;
			color: #d40b0b;
		}
	}
	.submittedSuccess {
		margin-top: 0;
		padding: 0 10px;
		.wx-share {
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: center;
			i {
				display: inline-block;
				width: 30px;
				height: 30px;
				background: url('../../assets/weixinlogo.png') no-repeat;
				background-size: 100%;
				cursor: pointer;
				margin-left: 10px;
			}
		}
		.tips {
			margin: 50px 0 !important;
		}
		.thank {
			font-size: 16px;
			color: #f63e35;
			.link {
				color: #5d90df;
				cursor: pointer;
			}
			.link + .link {
				display: inline-block;
				margin-left: 5px;
			}
		}
	}
	.isPassword {
		text-align: center;
		background-color: #fff;
		padding: 70px;
		margin-top: 100px;
		.input_box {
			position: relative;
			.form-item__error {
				display: flex;
				justify-content: center;
				width: 100%;
				text-align: left;
				margin: 0 auto;
				color: #f56c6c;
				font-size: 12px;
				line-height: 1;
				padding-top: 4px;
				top: 92px;
				span {
					display: inline-block;
					width: 50%;
				}
			}
			/deep/.input__err > .el-input__inner {
				border-color: #f56c6c;
			}
		}
		.title {
			font-weight: 650;
			font-size: 18px;
			color: #333333;
		}
		.input {
			margin: 50px 0;
			width: 50%;
		}
		.btn {
			padding: 10px 40px;
		}
	}
}

.selected {
	border: 1px solid #bae4f6 !important;
	background: #e8fbff;
	color: #2196f3;
}
.itemC {
	display: flex;
	align-items: center;
}

.tips-box {
	background: #fff;
	text-align: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 60%;
	min-width: 487px;
	height: 139px;
	margin: auto;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	padding: 20px;
	.title {
		font-size: 16px;
		padding-bottom: 50px;
	}
}
.isWx-content {
	width: 100%;
	background-color: #7c7c7c;
	height: 100vh;
	.isWX-tips-box {
		background-color: #fff;
		text-align: center;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 60%;
		height: 14%;
		margin: auto;
		border-radius: 5px;
		padding: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		.title {
			font-size: 16px;
			padding-bottom: 20px;
		}
		.tips-describe {
			font-size: 14px;
			color: #ccc;
		}
	}
	.wx-login {
		background-color: #3aae54;
		color: #fff;
	}
}
.isWx-content-pc {
	.isWX-tips-box {
		width: 16%;
		min-width: 245px;
		height: 317px;
		padding: 20px;
		box-sizing: border-box;
	}
	.qrCode-img {
		margin-bottom: 10px;
	}
}
.TM-content {
	background: aliceblue;
	width: 100%;
	height: 100vh;
}
.TM-tips-box,
.TM-continue-tips-box {
	background: #fff;
	text-align: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 88%;
	height: 17%;
	margin: auto;
	border-radius: 5px;
	padding: 10px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	.title {
		font-weight: 650;
		font-size: 16px;
		color: #169bd5;
	}
	.tips {
		font-size: 14px;
		background-color: #eaf2f8;
		margin: 11px 0;
		line-height: 30px;
	}
	.date {
		font-size: 14px;
		color: #d40b0b;
	}
}
.TM-continue-tips-box {
	.title {
		margin-bottom: 40px;
		font-weight: normal;
		font-size: 16px;
		color: #000;
	}
}
.TM-isPassword {
	background: #fff;
	text-align: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 88%;
	height: 25%;
	margin: auto;
	border-radius: 5px;
	padding: 10px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	.input_box {
		position: relative;
		.form-item__error {
			color: #f56c6c;
			font-size: 12px;
			line-height: 1;
			padding-top: 4px;
			position: absolute;
			top: 66px;
			left: 29px;
		}
		/deep/.input__err > .el-input__inner {
			border-color: #f56c6c;
		}
	}
	.title {
		font-weight: 650;
		font-size: 16px;
		color: #333333;
		padding-top: 10px;
	}
	.input {
		margin: 24px 0;
		width: 83%;
	}
	.btn {
		padding: 10px 40px;
	}
}
.TM-Dialog {
	/deep/.el-dialog__body {
		padding: none;
	}
}
.TM-submittedSuccess {
	text-align: center;
	background-color: #fff;
	padding: 10px;
	.title {
		font-weight: 650;
		font-size: 16px;
		color: #169bd5;
	}
	.tips {
		font-size: 14px;
		background-color: #eaf2f8;
		margin: 11px 0;
		line-height: 30px;
	}
	.thank {
		font-size: 14px;
		color: #f63e35;
		.link {
			color: #5d90df;
			cursor: pointer;
		}
		.link + .link {
			display: inline-block;
			margin-left: 5px;
		}
	}
}
.wx-share-dialog {
	/deep/.el-dialog {
		width: 300px !important;
	}
	.qrCode {
		text-align: center;
	}
}
/deep/.amap-geolocation-con{
	z-index: 100 !important;
}
.required::before {
	content: '*';
	color: #f56c6c;
	margin-right: 4px;
}
/deep/.el-tiptap-editor__content {
	[data-indent="1"]{
        text-indent: 1em !important;
		margin-left: 0 !important;
    }
	[data-indent="2"]{
        text-indent: 2em !important;
		margin-left: 0 !important;
    }
	[data-indent="3"]{
        text-indent: 3em !important;
		margin-left: 0 !important;
    }
	[data-indent="4"]{
        text-indent: 4em !important;
		margin-left: 0 !important;
    }
	[data-indent="5"]{
        text-indent: 5em !important;
		margin-left: 0 !important;
    }
	[data-indent="6"]{
        text-indent: 6em !important;
		margin-left: 0 !important;
    }
	[data-indent="7"]{
        text-indent: 7em !important;
		margin-left: 0 !important;
    }
}
</style>
